import React, {Component} from 'react';
import LocalizedStrings from '../localization/strings';
import DataTable from './data-table/data-table';
import moment from 'moment';
import {Link} from 'react-router';

export default class ParticipantResultsDisplay extends Component {


    render() {
        const {items, searchParams} = this.props;
        const extraCols = this.props.extraCols || [];
        if (!this.props.searchParams) {
            return null;
        }
        if (!items.length) {
            return <div>{LocalizedStrings.noResults}</div>
        }

        const config = {
            cols: [
                {
                    header: LocalizedStrings.stage,
                    value: (item) => {
                        return item.stage.name
                    }
                },
                {
                    header: LocalizedStrings.distance,
                    value: (item) => {
                        let distance = '';
                        item.stage.distances.forEach((dist) => {
                            if (dist.code.toLowerCase() === item.distance.toLowerCase()) {
                                distance = dist.name
                            }
                        });
                        return distance;
                        // return item.stage.name
                    }
                },
                {
                    header: LocalizedStrings.date,
                    value: (item) => {
                        return moment(item.stage.stage_date).format('YYYY-MM-DD')
                    }
                },
                {
                    header: LocalizedStrings.position,
                    value: (item) => {
                        return item.row[item.stage.results_field_position_poz - 1]
                    }
                },
                {
                    header: LocalizedStrings.result,
                    value: (item) => {
                        return item.row[item.row.length - 1]
                    }
                },
                {
                    header: '',
                    value: (item) => {
                        return (
                            <Link to={`/stages/${item.stage.id}/results`}
                                  className="btn btn-main-color inline ">
                                {LocalizedStrings.stageResults}
                            </Link>
                        )
                    }
                },
                ...extraCols
            ]
        };


        return (
            <div>
                <h3 className="first-uppercase">{LocalizedStrings.participant}: {searchParams.first_name} {searchParams.last_name}
                </h3>
                <div className="participant-results-history">
                    <DataTable config={config} items={items} responsive={true}/>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/js/components/participant-results-display.js